export const reviews = [
  {
    id: 'review-1',
    userName: '漫画迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20portrait%20of%20young%20woman%20with%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20features%2C%20clean%20background%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '基德漫画网的韩漫资源太丰富了！我每天都在这里看最新的韩漫，下拉式阅读体验真的很棒，翻页流畅，画质也很清晰。推荐给所有喜欢韩漫的朋友！',
    date: '2026-06-28',
  },
  {
    id: 'review-2',
    userName: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20portrait%20of%20young%20man%20with%20warm%20lighting%2C%20minimalist%20style%2C%20clean%20background%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '从朋友推荐过来看的，没想到这里的韩漫这么全。更新速度也很快，热门漫画基本同步更新。免费阅读的体验超出预期！',
    date: '2026-06-25',
  },
  {
    id: 'review-3',
    userName: '月光下的读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20illustrated%20portrait%20of%20young%20woman%20with%20glasses%20and%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20features%2C%20clean%20background%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '网站排版很舒服，分类也很清晰。下拉式的阅读方式适合手机观看，通勤时间就能追几话。要是能增加夜间模式就更完美了。',
    date: '2026-06-20',
  },
];